const arMessages = {
  dropdowns: {
      nodata: 'لم يتم العثور على محتوى',
      clear: 'مسح',
      comboArrowBtnAriaLabelExpand: 'توسيع مربع التحرير والسرد',
      comboArrowBtnAriaLabelCollapse: 'طي مربع التحرير والسرد',
      dropDownListArrowBtnAriaLabel: 'اختر'
  }
};

export default arMessages;
